import React from 'react'

export const AppleIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" width="44.621" height="44.619" viewBox="0 0 44.621 44.619">
      <path id="apple-icon" fill="#D7DF23" d="M0 0v44.62h44.62V0H0zm33.86 30.149v1.3c0 1.971-1.52 3.57-3.399 3.57h-3.03c-1.88 0-3.4-1.6-3.4-3.57 0-.989.38-1.88 1-2.529.61-.65 1.46-1.051 2.4-1.051h3.03c1.029.051 1.5-.5 1.479-1.1v-11.85c0-.51-.399-.84-.89-.75l-12.79 2.49c-.5.1-.9.58-.9 1.09v16.83c0 1.971-1.52 3.57-3.39 3.57h-3.04c-1.87 0-3.39-1.6-3.39-3.57 0-.989.38-1.88.99-2.529.62-.65 1.46-1.05 2.4-1.05h3.04c1.1.02 1.51-.551 1.51-1.08V11.03c0-.64.5-1.26 1.12-1.38l16.14-3.13c.62-.12 1.12.3 1.12.94v22.689z" />
    </svg>
  )
}